import { useNavigate, useParams } from 'react-router-dom';
import { usePluginspace } from '../../hooks/usePluginspace';
import api from '../../services/api';
import './index.css'
import { CategoryType } from '../../contexts/CategoryContext';
import { useCategory } from '../../hooks/useCategory';
import { useEffect, useState } from 'react';
import LazyImage from '../LazyImage/LazyImage';

type SubcategoryItemProps = {
    item: CategoryType
    blockFormat: boolean;
    legendColor: string;
    food?: boolean;
    setLoading: (value: boolean) => void;
    noShadow: boolean;
    useShadow: boolean;
    showClassificationName: boolean;
    classe: string;
}

export function SubcategoryItem({ item, blockFormat, legendColor, food = false, setLoading, noShadow,useShadow, showClassificationName }: SubcategoryItemProps) {
    const navigate = useNavigate();
    const { pluginspace_id } = useParams();
    const { getSubcategories } = useCategory();
    const [loadingImage, setLoadingImage] = useState(true);

    async function navigateSubcategory() {
        setLoading(true);
        const subs = await getSubcategories(item.id.toString());
        if (subs.length > 0) {
            navigate(`/${pluginspace_id}/subcategory/${item.id}`);
        } else {
            if (food) {
                navigate(`/${pluginspace_id}/products?subcategory=${item.id}`);
            } else {
                navigate(`/${pluginspace_id}/pdv/${item.id}`);
            }
        }
        setLoading(false);

    }

    useEffect(() => {
        if (item.img) {
            const img = new Image()
            img.src = item.img
            img.onload = () => setLoadingImage(false)
        }
    }, [item.img])

    return (
        <>
            <div
                className={`${blockFormat ? "subcategory-item " : !food ? "subcategory-item-flat-varejo" : "subcategory-item-flat"} item ${!food && `subcategory-rounded-12397uy`}`}
                style={noShadow ? { boxShadow: 'none' } : {}}
                onClick={() => navigateSubcategory()}
            >
                {useShadow && <div className="overlay"></div>}
                <LazyImage
                    src={item.img}
                    alt={item.name}
                    className={`image_subcategory_item_127963768`} />

                {food || showClassificationName &&
                    <>
                        {food ?
                            <h2 style={{ color: legendColor }}>{item.name}</h2> :
                            <span className='span_subcategory_item' style={{ color: legendColor }}>{item.name}</span>
                        }
                    </>

                }
            </div>
        </>
    )
}